// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  defaultLang: 'pl',
  langList: ['pl', 'en'],

  keycloakAuthUrl: 'https://wtr.sims.pl/auth',
  keycloakRealm: 'realm',
  keycloakClientId: 'stp2client',
  refreshTokenRetryInterval: 1 * 60 * 1000, // in ms
  updateTokenWaitingTime: 5 * 1000, // Time (in ms) after which error information is sent for incomplete update token operation.

  serverUrl: 'https://wtr.sims.pl/stp3/',
  prometheusUrl: 'http://localhost:9090',
  grafanaUrl: 'http://localhost:3000',
  snvrServerUrl: 'http://localhost:8097/',
  dsList: new Map<string, string>(),
  janusServerUrl: 'ws://192.168.109.149:8188',
  janusSecret: 'serversecret',
  sakpServerUrl: 'https://wtr.sims.pl/sakp/'
};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.

